import { GrowthBookProvider } from '@growthbook/growthbook-react'
import ReactDOM from 'react-dom/client'
import React from 'react'

import { growthbook } from './plugins/growthbook'
import './plugins/date-fns'
import './plugins/sentry'
import './plugins/i18n'

import { AuthProvider } from '@/components/AuthProvider.tsx'
import { ToastProvider } from '@/components/ToastProvider.tsx'
import { App } from '@/App.tsx'

import '@radix-ui/themes/styles.css'
import '@/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GrowthBookProvider growthbook={growthbook}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </GrowthBookProvider>
  </React.StrictMode>
)
